import { render, staticRenderFns } from "./_breadcrumbs.vue?vue&type=template&id=6ace056a&"
import script from "./_breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./_breadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports